



function Carousel({search,setsearch}) {
  
    const clicked = (e)=>{
        e.preventDefault()
       setsearch("")
    }
  return (
   <>
  
<form action="" className='fm'>
<input type="text" placeholder='search...' value={search} onChange={(e)=>{
 setsearch(e.target.value)
}}/>
<button className='btn' onClick={clicked}>show all food</button>
</form>

   </>
  )
}

export default Carousel
